import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { events } from "@/mocks/events";
import { timelineMeta } from "@/utils/timeline";

export default function LiveTimeline() {
  const nodes = events.flatMap((ev) =>
    ev.timeline.map((node) => ({
      time: node.time,
      title: node.title,
      desc: node.desc,
      type: node.type,
      eventId: ev.id,
      eventTitle: ev.title,
      category: ev.category,
    }))
  );
  const sorted = [...nodes].sort((a, b) => (a.time < b.time ? 1 : -1)).slice(0, 9);

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Live Timeline"
          title="正在追踪 · 实时时间线"
          desc="把散落各处的进展按发生顺序排列，标注首发、更新、反转与后续，方便你一眼看清事件走向。"
          action={
            <Link
              to="/events"
              className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览全部时间线
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <div className="mt-8 -mx-4 md:mx-0 px-4 md:px-0 overflow-x-auto rail-scroll">
          <div className="flex gap-4 pb-4 min-w-max md:min-w-0">
            {sorted.map((node, index) => {
              const meta = timelineMeta[node.type];
              return (
                <Link
                  key={`${node.eventId}-${node.time}-${index}`}
                  to={`/events/${node.eventId}`}
                  className="group w-[280px] shrink-0 flex flex-col gap-3 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
                >
                  <div className="flex items-center justify-between">
                    <span className={`px-2 py-0.5 rounded-full border text-[11px] ${meta.chip}`}>
                      {meta.label}
                    </span>
                    <span className="text-[11px] text-foreground-400">{node.time}</span>
                  </div>
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {node.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600 line-clamp-3">{node.desc}</p>
                  <div className="mt-auto pt-3 border-t border-background-200 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-400" />
                    <span className="truncate">{node.category} · {node.eventTitle}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}